import Result from "../models/result";
import SubResult from "../models/subresult";
import DateHelper from "./date-helper";
import Appointment from "../models/appointment";
import DictionaryItem from "../models/dictionary-item";

class AppointmentHelper {
    static getAppointmentsCount(result: Result, date: Date): number {
        let num = 0;
        result.subResults.map((sub: SubResult) => {
            const subDate = new Date(sub.appointmentsDate);
            if (subDate.getTime() === date.getTime()) {
                num = sub.appointmentsCounter;
            }
        })
        return num;
    }

    static getDaysToFetch(lastPossibleDate: Date, appointmentDate: Date): number {
        const daysToFetch = 7;
        const pastDates = [];

        // prepare past dates for next check
        for (let i = 1; i <= 6; i++) {
            const dateAsNumber = new Date(DateHelper.addDays(lastPossibleDate, -i)).setHours(0, 0, 0, 0);
            const newDate = new Date(dateAsNumber);
            pastDates.push(newDate);
        }

        // check if less than 7 days
        for (let i = 0; i < 6; i++) {
            if (pastDates[i].getTime() <= appointmentDate.getTime()) {
                return i + 1;
            }
        }
        return daysToFetch;
    }

    // static isAnyAppointmentInResult(result: Result, selectedRegionCode: string, selectedSpecialisationCode: string, serviceInOffice: boolean, selectedDate: Date): boolean {        
    //     if (result.subResults.length > 0 && serviceInOffice && selectedDate) {
    //         const matchedSubResults = result.subResults.filter((sub: SubResult) => sub.appointments.every((app: Appointment) => app.region.code === selectedRegionCode && selectedSpecialisationCode.includes(app.specialty.code)));
    //         return matchedSubResults.some((sub: SubResult) => sub.appointments.length > 0);
    //     }
    //     return false;
    // }

    static areNoAppointmentsInResult(result: Result, selectedRegionCode: string, selectedSpecialisationCode: string, serviceInOffice: boolean): boolean {
        if (serviceInOffice && result.subResults.length > 0) {
            const matchedSubResults = result.subResults.filter((sub: SubResult) => sub.appointments.every((app: Appointment) => app.region.code === selectedRegionCode && selectedSpecialisationCode.includes(app.specialty.code)));
            return matchedSubResults.every((sub: SubResult) => sub.appointments.length === 0);
        }
        else {
            return selectedRegionCode.length > 0 && selectedSpecialisationCode.length > 0;
        }
    }

    static getPresentedDates(result: Result, start: number, stop: number): Date[] {
        return result.subResults.map((sub: SubResult) => sub.appointmentsDate).slice(start, stop);
    }

    static getFirstSelectedIndex(result: Result, allDays: Date[], index: number): number {
        if (index === 0) {
            for (let i = 0; i < allDays.length; i++) {
                const d = new Date(allDays[i].setHours(0, 0, 0, 0));
                for (let subResult of result.subResults) {
                    if (d.getTime() === subResult.appointmentsDate.getTime()) {
                        return i;
                    }
                }
            }
        }
        return index;
    }

    static getSelectedIndex(allDays: Date[], date: Date): number {
        for (let i = 0; i < allDays.length; i++) {
            const d = new Date(allDays[i].setHours(0, 0, 0, 0));
            if (d.getTime() === date.getTime()) {
                return i;
            }
        }
        return 0;
    }

    static getClinics(result: Result, date: Date): DictionaryItem[] {
        let clinics: DictionaryItem[] = [];
        for (let sub of result.subResults) {
            if (sub.appointmentsDate.getTime() === date.getTime()) {
                for (let app of sub.appointments) {
                    const item = new DictionaryItem();
                    item.code = app.clinic.code;
                    item.description = app.clinic.description;
                    item.dictionaryType = app.clinic.dictionaryType;
                    if (item.description && item.description.trim().length > 0) {
                        clinics.push(item);
                    }
                }
            }
        }

        clinics = this.removeClinicsDuplicates(clinics);
        clinics.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0)); // sort alphabetically by description
        return clinics;
    }

    static getSpecialists(result: Result, date: Date): DictionaryItem[] {
        let specialists: DictionaryItem[] = [];
        for (let sub of result.subResults) {
            if (sub.appointmentsDate.getTime() === date.getTime()) {
                for (let app of sub.appointments) {
                    const item = new DictionaryItem();
                    item.code = app.doctor.code;
                    item.description = app.doctor.description;
                    item.dictionaryType = app.doctor.dictionaryType;
                    if (item.description && item.description.trim().length > 0) {
                        specialists.push(item);
                    }
                }
            }
        }

        specialists = this.removeSpecialistsDuplicates(specialists);
        specialists.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0)); // sort alphabetically by description
        return specialists;
    }

    static removeClinicsDuplicates(clinics: DictionaryItem[]): DictionaryItem[] {
        return clinics.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.description === thing.description
            ))
        )
    }

    static removeSpecialistsDuplicates(specialists: DictionaryItem[]): DictionaryItem[] {
        return specialists.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.description === thing.description
            ))
        )
    }

    static removeSubresultsDuplicates(result: Result, selectedRegionCode: string, selectedSpecialtyCode: string): Result {
        result.subResults = result.subResults.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                DateHelper.areDatesEqual(t.appointmentsDate, thing.appointmentsDate) && t.appointments.every((app : Appointment) => selectedRegionCode.includes(app.region.code) && selectedSpecialtyCode.includes(app.specialty.code))
            ))
        )
        return result;
    }

    static getDoctorNameAndSurname(doctorDescription: string) {
        const details: string[] = doctorDescription.split(" ");
        return details;
    }
}

export default AppointmentHelper;

